// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GoldOutlinedSvg from "@fishx/icons-svg/es/asn/GoldOutlined";
import FishxIcon from '../components/FishxIcon';

var GoldOutlined = function GoldOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: GoldOutlinedSvg
  }));
};

GoldOutlined.displayName = 'GoldOutlined';
export default React.forwardRef(GoldOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/GoldOutlined.js
// module id = 2886
// module chunks = 0